__turbopack_context__.v({
  "avatarContainer": "YxAQ1a_avatarContainer",
  "avatarWrapper": "YxAQ1a_avatarWrapper",
  "deleteBtn": "YxAQ1a_deleteBtn",
  "imagePreview": "YxAQ1a_imagePreview",
  "replaceBtn": "YxAQ1a_replaceBtn",
});
